import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import type { Category } from "@/data/certificates";
import { cn } from "@/lib/utils";

type CategoryBadgeProps = {
  category: Category;
  /** Soft (default on cards) or solid white / primary */
  tone?: "soft" | "white" | "primary";
  size?: "sm" | "md";
  /** When true, links to starta-arende for that area */
  link?: boolean;
  className?: string;
};

const toneClass = {
  soft: "border border-primary/10 bg-primary-soft text-primary shadow-[0_2px_6px_-2px_hsl(162_52%_8%/0.12)]",
  white: "border border-border/60 bg-white text-foreground shadow-card hover:border-primary/25 hover:text-primary",
  primary:
    "border border-primary/20 bg-primary text-primary-foreground shadow-[0_2px_8px_-2px_hsl(162_52%_8%/0.35)]",
} as const;

export const CategoryBadge = ({
  category,
  tone = "soft",
  size = "sm",
  link = false,
  className,
}: CategoryBadgeProps) => {
  const { t, lang } = useLang();
  const label = t.categories[category];
  const classes = cn(
    "inline-flex items-center justify-center rounded-full font-medium leading-none transition-base",
    size === "sm" ? "h-7 px-3 text-[11px]" : "h-8 px-3.5 text-xs",
    toneClass[tone],
    className,
  );

  if (link) {
    return (
      <Link
        to={`${lang === "sv" ? "/starta-arende" : "/en/start-case"}?omrade=${category}`}
        className={classes}
      >
        {label}
      </Link>
    );
  }

  return <span className={classes}>{label}</span>;
};
